import { MONEY_DECIMALS, roundMoney } from 'shared-models/browser';

export { MONEY_DECIMALS, roundMoney };

export function formatMoney(value: number): string {
  return roundMoney(value).toFixed(MONEY_DECIMALS);
}

/** Like formatMoney but drops the decimal when it's .0 (e.g. 5.0 → "5", 5.5 → "5.5") */
export function formatMoneyCompact(value: number): string {
  const fixed = roundMoney(value).toFixed(MONEY_DECIMALS);
  return fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed;
}
